import {Repository} from "aurelia-orm";

export class AppRepository extends Repository {
    
    call(path:string, criteria:any) {

        let fullPath = this.getResource() + "/" + path;

		return this.findPath(fullPath, criteria, true);
    }
}